import { render, staticRenderFns } from "./homepanel.vue?vue&type=template&id=83135e36&scoped=true"
import script from "./homepanel.vue?vue&type=script&lang=js"
export * from "./homepanel.vue?vue&type=script&lang=js"
import style0 from "./homepanel.vue?vue&type=style&index=0&id=83135e36&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83135e36",
  null
  
)

export default component.exports